import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityUniversity/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteQualityUniversityById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityUniversity/deleteQualityUniversityById`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateImport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityUniversity/templateImport`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveQualityUniversity({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityUniversity/saveQualityUniversity`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateUpload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/qualityUniversity/templateUpload',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },






}
